import React from "react";
import { Container, Row, Col, Breadcrumb } from "react-bootstrap";
import CTABtnModule from "../../modules/cta_btn_module";
import BreadCrumbs from "./BreadCrumbs";
import ImageModule from "../../modules/image_module";
import "./StaticBanner.scss";

const StaticBanner = ({ banner_section, GQLPage }) => { 

    var imagename = "pages.banner_section_banner_image.landing_banner_image";

    let processedImages = JSON.stringify({});
    if (GQLPage?.imagetransforms?.banner_section_banner_image_Transforms) {
        processedImages = GQLPage?.imagetransforms?.banner_section_banner_image_Transforms;
    }

    return (
        <React.Fragment>           
            <section className="static-banner">
                
                <ImageModule ImageSrc={banner_section?.banner_image} altText={banner_section?.title} imagetransforms={processedImages} renderer="bgImg" imagename={imagename} strapi_id={GQLPage?.id} classNames="banner_img" />

                <span className="transp_bg"></span>

                {GQLPage && <BreadCrumbs GQLPage={GQLPage}/> }

                <Container>
                    <Row>
                        <Col>
                            <div className="banner-content">
                                {banner_section?.title && <h1>{banner_section.title}</h1>}
                                {banner_section?.content &&
                                    <p className="sm-text">
                                        {banner_section.content}
                                    </p>
                                }

                                {(banner_section?.button_cta_1?.label || banner_section?.button_cta_2?.label) &&
                                    <div className="btn-wrapper">
                                        {banner_section?.button_cta_1?.label &&
                                            <CTABtnModule button_cta={banner_section?.button_cta_1} />
                                        }
                                        {banner_section?.button_cta_2?.label &&
                                            <CTABtnModule button_cta={banner_section?.button_cta_2} />
                                        }
                                    </div>
                                }
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </React.Fragment>
    );
};
export default StaticBanner;
